module["exports"] = [
  "###-###-####",
  "(###) ###-####",
  "1-###-###-####",
  "###.###.####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/cell_phone/formats.js
// module id = 867
// module chunks = 1